export default "__VITE_ASSET__rYcHX$H1__"